import { z } from 'zod';

/** Cursorpaginering volgens docs/conventions/api.md (max 100 per pagina). */
export const cursorQuerySchema = z.object({
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type CursorQuery = z.infer<typeof cursorQuerySchema>;

export function pageSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
}

/**
 * Hoeveel er in een lijst staat, zonder de lijst zelf (OPR-3).
 *
 * Voor de tellers in de zijbalk van het beheer. Die telden eerst de eerste pagina van de lijst,
 * en toonden dus nooit meer dan 50, 100 of 200 - ook als er meer wachtte. Een aparte telroute
 * naast de lijst, met dezelfde filters en rechten, geeft het echte getal zonder de rijen op te
 * halen en op te maken.
 */
export const listCountSchema = z.object({ count: z.number().int().min(0) });
export type ListCount = z.infer<typeof listCountSchema>;
